import { useEffect, useState } from "react";
import PlansRepository from "../api/PlansRepository";
import { Plan } from "../types";

interface PlansState {
  plans: Plan[];
  loading: boolean;
  error: string | null;
}

export function usePlans(): PlansState {
  const [state, setState] = useState<PlansState>({ plans: [], loading: true, error: null });

  useEffect(() => {
    let alive = true;
    PlansRepository.getAll()
      .then((plans) => alive && setState({ plans, loading: false, error: null }))
      .catch(() => alive && setState({ plans: [], loading: false, error: "Não foi possível carregar os planos." }));
    return () => {
      alive = false;
    };
  }, []);

  return state;
}
